// Two layouts in one app (D6): /floor for the tablet, /lead for the desk.
import type { RouteObject } from 'react-router';
import { Navigate, useOutletContext } from 'react-router';

import { AuthCallback } from '../auth/AuthCallback';
import { BuildPage } from '../features/build/BuildPage';
import { DemoPage } from '../features/lead/DemoPage';
import { InstructionEditorPage } from '../features/lead/InstructionEditor';
import { InstructionsPage } from '../features/lead/InstructionsPage';
import { LeadBuildPage } from '../features/lead/LeadBuildPage';
import { NumbersPage } from '../features/lead/NumbersPage';
import { OverviewPage } from '../features/lead/OverviewPage';
import { ProblemsPage } from '../features/lead/ProblemsPage';
import { QueueOrderPage } from '../features/lead/QueueOrderPage';
import { RecordPage } from '../features/lead/RecordPage';
import { RecordsPage } from '../features/lead/RecordsPage';
import { StationsPage } from '../features/lead/StationsPage';
import { QueuePage } from '../features/queue/QueuePage';
import { FloorLayout } from '../layouts/FloorLayout';
import { LeadLayout } from '../layouts/LeadLayout';
import { NotFound } from './NotFound';

function StationQueue() {
    const station = useOutletContext<string>();
    return <QueuePage station={station} />;
}

export const routes: RouteObject[] = [
    { path: '/', element: <Navigate to="/floor" replace /> },
    { path: '/auth/callback', element: <AuthCallback /> },
    {
        path: '/floor',
        element: <FloorLayout />,
        children: [
            { index: true, element: <StationQueue /> },
            { path: 'builds/:buildId', element: <BuildPage /> },
        ],
    },
    {
        path: '/lead',
        element: <LeadLayout />,
        children: [
            { index: true, element: <OverviewPage /> },
            { path: 'builds/:buildId', element: <LeadBuildPage /> },
            { path: 'queue', element: <QueueOrderPage /> },
            { path: 'instructions', element: <InstructionsPage /> },
            { path: 'instructions/:instructionSetId', element: <InstructionEditorPage /> },
            { path: 'problems', element: <ProblemsPage /> },
            { path: 'records', element: <RecordsPage /> },
            { path: 'records/:buildId', element: <RecordPage /> },
            { path: 'numbers', element: <NumbersPage /> },
            { path: 'stations', element: <StationsPage /> },
            { path: 'demo', element: <DemoPage /> },
        ],
    },
    { path: '*', element: <NotFound /> },
];
